import tagTester from './_tagTester.js';

export default tagTester('Date');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isDate.js
// module id = 197
// module chunks = 0 1